<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddBadwordToBlacklist" @submit="formSubmit($event, 'addBadwordToBlacklist')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addBadwordToBlacklist',
                    fieldName:'badword'
                })"
                :value.sync="$v.forms.addBadwordToBlacklist.badword.$model"
                :label="$t('badword')"
                :disables="true"
            />
            <!-- <CTextarea
                :isValid="checkIfFormValid({
                    formName:'addBadwordToBlacklist',
                    fieldName:'reason'
                })"
                :value.sync="$v.forms.addBadwordToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
            /> -->
             <CSelect
                :isValid="
                    checkIfFormValid({
                        formName: 'addBadwordToBlacklist',
                        fieldName: 'reason',
                    })
                "
                :value.sync="$v.forms.addBadwordToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
                :placeholder="'Select type'"
                :options="[
                    { label: 'Insults', value: 'Insults' },
                    { label: 'Spelling errors', value: 'Spelling errors' },
                    { label: 'Manual Lock', value: 'Manual Lock' },
                    { label: 'Blocked abbreviations', value: 'Blocked abbreviations' },
                ]"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addBadwordToBlacklist._loading"
            >
                <span>{{ $t('Save') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("Cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addBadwordToBlacklist._loading">
                {{ $t("Save") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators"
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "AddBadwordToBlacklistModal",
    mixins: [formMixin, validationMixin],
    components: {
        ButtonLoading
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                addBadwordToBlacklist:{
                    badword: null,
                    reason: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            addBadwordToBlacklist:{
                badword:{
                    required
                },
                reason:{
                    required
                }
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('addBadwordToBlacklist');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/headers.api/blacklist/badwords'
            });
            this.showComponent = false;

            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formAddBadwordToBlacklist.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
};
</script>

<style>
</style>